// Hooks
import { defineStore } from "pinia";
import { computed, reactive, ref } from "vue";

// Types
import type { I_it4CreateContract_Return } from "@/hooks/requests/it4CreateContract/it4CreateContract.types";

import { useTIWStore } from "@/stores/tiw/tiw";

import type { I_Individual_Field } from "./successfulEvaluation.types";

const PESEL_USED_API_STATUS = "pesel_used";

/**
 * 🆂🆃🅾🆁🅴 [Successful Evaluation]
 */
export const useSuccessfulEvaluationStore = defineStore("successfulEvaluation", () => {
    const TIWStore = useTIWStore();
    // |-------|
    // | STATE |
    // |-------|

    const individualFields = reactive<I_Individual_Field>({
        PESEL: "",
        name: "",
        surname: "",
        idNumber: "",
        dateOfIssue: "",
        postalCode: "",
        street: "",
        houseNumber: "",
        city: "",
        apartmentNumber: "",
        email: "",
        phone: "",
        personal: false,
        isFinalPriceOkay: false,
        duty: false,
    });

    const contractData = ref<null | I_it4CreateContract_Return>(null);
    const isPeselAlreadyUsedForContract = computed(
        () => contractData.value.status === PESEL_USED_API_STATUS,
    );

    // |----------|
    // | COMPUTED |
    // |----------|

    const isAcceptedToNext = computed<boolean>(() => {
        let key: keyof I_Individual_Field;
        for (key in individualFields) {
            if (Object.prototype.hasOwnProperty.call(individualFields, key)) {
                if (key === "apartmentNumber") continue;
                if (key === "isFinalPriceOkay" && !TIWStore.IS_DISCOUNT_LATER) continue;
                if (individualFields[key]) continue;
                return false;
            }
        }

        return true;
    });

    // |---------|
    // | METHODS |
    // |---------|

    const restoreToDefault = () => {
        contractData.value = null;
        let individualKey: keyof I_Individual_Field;

        for (individualKey in individualFields) {
            if (Object.prototype.hasOwnProperty.call(individualFields, individualKey)) {
                if (typeof individualFields[individualKey] === "boolean") {
                    (individualFields[individualKey] as boolean) = false;
                } else {
                    (individualFields[individualKey] as string) = "";
                }
            }
        }
    };

    const address = computed(() => {
        return `${individualFields.street} ${individualFields.houseNumber}, apt. ${individualFields.apartmentNumber}`.trim();
    });

    return {
        // * 🆂🆃🅾🆁🅴
        individualFields,
        contractData,
        isPeselAlreadyUsedForContract,
        address,

        // * 🅲🅾🅼🅿🆄🆃🅴🅳
        isAcceptedToNext,

        // * 🅼🅴🆃🅷🅾🅳🆂
        restoreToDefault,
    };
});
